const constants = {
  roles: [
    {
      label: 'User',
      value: 1,
    },
    {
      label: 'Admin',
      value: 2,
    },
    {
      label: 'Manager',
      value: 3,
    },
    {
      label: 'Pm user',
      value: 4,
    },
    {
      label: 'Artist',
      value: 5,
    },
    {
      label: 'Artist lead',
      value: 6,
    },
    {
      label: 'Sales',
      value: 7,
    },
    {
      label: 'Sales manager',
      value: 8,
    },
    {
      label: 'Project manager',
      value: 9,
    },
    {
      label: 'Technician',
      value: 10,
    },
    {
      label: 'Social',
      value: 11,
    },
    {
      label: 'Pod admin',
      value: 12,
    },
    {
      label: 'Pod user',
      value: 13,
    },
  ],
  states: [
    {
      label: 'Alabama',
      value: 'AL',
    },
    {
      label: 'Alaska',
      value: 'AK',
    },
    {
      label: 'Arizona',
      value: 'AZ',
    },
    {
      label: 'Arkansas',
      value: 'AR',
    },
    {
      label: 'California',
      value: 'CA',
    },
    {
      label: 'Colorado',
      value: 'CO',
    },
    {
      label: 'Connecticut',
      value: 'CT',
    },
    {
      label: 'District of Columbia',
      value: 'DC',
    },
    {
      label: 'Delaware',
      value: 'DE',
    },
    {
      label: 'Florida',
      value: 'FL',
    },
    {
      label: 'Georgia',
      value: 'GA',
    },
    {
      label: 'Hawaii',
      value: 'HI',
    },
    {
      label: 'Idaho',
      value: 'ID',
    },
    {
      label: 'Illinois',
      value: 'IL',
    },
    {
      label: 'Indiana',
      value: 'IN',
    },
    {
      label: 'Iowa',
      value: 'IA',
    },
    {
      label: 'Kansas',
      value: 'KS',
    },
    {
      label: 'Kentucky',
      value: 'KY',
    },
    {
      label: 'Louisiana',
      value: 'LA',
    },
    {
      label: 'Maine',
      value: 'ME',
    },
    {
      label: 'Maryland',
      value: 'MD',
    },
    {
      label: 'Massachusetts',
      value: 'MA',
    },
    {
      label: 'Michigan',
      value: 'MI',
    },
    {
      label: 'Minnesota',
      value: 'MN',
    },
    {
      label: 'Mississippi',
      value: 'MS',
    },
    {
      label: 'Missouri',
      value: 'MO',
    },
    {
      label: 'Montana',
      value: 'MT',
    },
    {
      label: 'Nebraska',
      value: 'NE',
    },
    {
      label: 'Nevada',
      value: 'NV',
    },
    {
      label: 'New Hampshire',
      value: 'NH',
    },
    {
      label: 'New Jersey',
      value: 'NJ',
    },
    {
      label: 'New Mexico',
      value: 'NM',
    },
    {
      label: 'New York',
      value: 'NY',
    },
    {
      label: 'North Carolina',
      value: 'NC',
    },
    {
      label: 'North Dakota',
      value: 'ND',
    },
    {
      label: 'Ohio',
      value: 'OH',
    },
    {
      label: 'Oklahoma',
      value: 'OK',
    },
    {
      label: 'Oregon',
      value: 'OR',
    },
    {
      label: 'Pennsylvania',
      value: 'PA',
    },
    {
      label: 'Rhode Island',
      value: 'RI',
    },
    {
      label: 'South Carolina',
      value: 'SC',
    },
    {
      label: 'South Dakota',
      value: 'SD',
    },
    {
      label: 'Tennessee',
      value: 'TN',
    },
    {
      label: 'Texas',
      value: 'TX',
    },
    {
      label: 'Utah',
      value: 'UT',
    },
    {
      label: 'Vermont',
      value: 'VT',
    },
    {
      label: 'Virginia',
      value: 'VA',
    },
    {
      label: 'Washington',
      value: 'WA',
    },
    {
      label: 'West Virginia',
      value: 'WV',
    },
    {
      label: 'Wisconsin',
      value: 'WI',
    },
    {
      label: 'Wyoming',
      value: 'WY',
    },
  ],
  FONT_FAMILY_OPTIONS: [
    {
      label: 'Egptienne - Bold',
      value: 'Egptienne_Bold',
    },
    {
      label: 'Recoleta',
      value: 'Recoleta',
    },
    {
      label: 'Montserrat',
      value: 'Montserrat',
    },
    {
      label: 'Futura-Book',
      value: 'Futura_Book',
    },
    {
      label: 'Railway - Light',
      value: 'Railway_Light',
    },
    {
      label: 'Pier_Sans_Bold',
      value: 'Pier_Sans_Bold',
    },
    {
      label: 'Market_Fresh',
      value: ' Market_Fresh',
    },
    {
      label: 'Bodoni - Medium',
      value: 'Bodoni_Medium',
    },
    {
      label: 'Libre Baskerville - Regular',
      value: 'Libre_Baskerville_Regular',
    },
    {
      label: 'Neutraface-Text-Book',
      value: 'Neutraface_Text_Book',
    },
    {
      label: 'Work Sans',
      value: 'Work Sans',
    },
    {
      label: 'Life Savers',
      value: 'Life Savers',
    },
    {
      label: 'Yellowtail',
      value: 'Yellowtail',
    },
    {
      label: 'Montez',
      value: 'Montez',
    },
    {
      label: 'Yesteryear',
      value: 'Yesteryear',
    },
    {
      label: 'Molle',
      value: 'Molle',
    },
    {
      label: 'Lavishly Yours',
      value: 'Lavishly Yours',
    },
    {
      label: 'IM Fell English SC',
      value: 'IM Fell English SC',
    },
    {
      label: 'La Belle Aurore',
      value: 'La Belle Aurore',
    },
    {
      label: 'Shrikhand',
      value: 'Shrikhand',
    },
    {
      label: 'Bungee Shade',
      value: 'Bungee Shade',
    },
    {
      label: 'Monoton',
      value: 'Monoton',
    },
    {
      label: 'Alex Brush',
      value: 'Alex Brush',
    },
    {
      label: 'Allura',
      value: 'Allura',
    },
    {
      label: 'Spicy Rice',
      value: 'Spicy Rice',
    },
    {
      label: 'Sacramento',
      value: 'Sacramento',
    },
    {
      label: 'Kalam',
      value: 'Kalam',
    },
    {
      label: 'Great Vibes',
      value: 'Great Vibes',
    },
    {
      label: 'Satisfy',
      value: 'Satisfy',
    },
    {
      label: 'Shadows Into Light',
      value: 'Shadows Into Light',
    },
    {
      label: 'Lobster',
      value: 'Lobster',
    },
    {
      label: 'Caveat',
      value: 'Caveat',
    },
    {
      label: 'Pacifico',
      value: 'Pacifico',
    },
    {
      label: 'EB Garamond',
      value: 'EB Garamond',
    },
    {
      label: 'Dancing Script',
      value: 'Dancing Script',
    },
    {
      label: 'Bebas Neue',
      value: 'Bebas Neue',
    },
    {
      label: 'Merriweather',
      value: 'Merriweather',
    },
    {
      label: 'Morion',
      value: 'Morion',
    },
    {
      label: 'Inter',
      value: 'Inter',
    },
    {
      label: 'ahmedy webfont',
      value: 'ahmedy_webfont',
    },
    {
      label: 'dark moon webfont',
      value: 'dark_moon_webfont',
    },
    {
      label: 'elegant webfont',
      value: 'elegant_webfont',
    },
    {
      label: 'ethereal medium webfont',
      value: 'ethereal_medium_webfont',
    },
    {
      label: 'mango dream webfont',
      value: 'mango_dream_webfont',
    },
    {
      label: 'mindstay webfont',
      value: 'mindstay_webfont',
    },
    {
      label: 'MontrealLight',
      value: 'MontrealLight',
    },
    {
      label: 'romantic history webfont',
      value: 'romantic_history_webfont',
    },
    {
      label: 'romantica webfont',
      value: 'romantica_webfont',
    },
    {
      label: 'vintage grunge regular webfont',
      value: 'vintage_grunge_regular_webfont',
    },
  ],
  FONT_WEIGHT_OPTIONS: [
    {
      label: 'Extra Light',
      value: 100,
    },
    {
      label: 'Light',
      value: 300,
    },
    {
      label: 'Regular',
      value: 400,
    },
    {
      label: 'Medium',
      value: 500,
    },
    {
      label: 'Extra medium',
      value: 600,
    },
    {
      label: 'Bold',
      value: 700,
    },
    {
      label: 'Extra bold',
      value: 800,
    },
    {
      label: 'Black',
      value: 900,
    },
  ],
  ALIGNMENT_OPTIONS: [
    {
      label: 'Left',
      value: 'flex-start',
    },
    {
      label: 'Center',
      value: 'center',
    },
    {
      label: 'Right',
      value: 'flex-end',
    },
  ],
  VERTICAL_ALIGNMENT_OPTIONS: [
    {
      label: 'Top',
      value: 'flex-start',
    },
    {
      label: 'Center',
      value: 'center',
    },
    {
      label: 'Bottom',
      value: 'flex-end',
    },
  ],
};

export default constants;
